<template>
    <div class="shortcuts-container">
        <div class="shortcuts-section">
            <div class="section-header">
                <div class="os-header">
                    <i class="fa-brands fa-windows"></i>
                    <h3>{{ $t("message.windows") }}</h3>
                </div>
                <div class="divider"></div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">CTRL</b-badge>
                    +
                    <b-badge variant="primary">M</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.openPrivateChat") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">ESC</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.escKey") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">CTRL</b-badge>
                    +
                    <b-badge variant="primary">K</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("search.searchAreaTitle") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">F1</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.focusInput") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">F4</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.previousOpenedChat") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">TAB</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.showSystemStatus") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">CTRL</b-badge>
                    +
                    <b-badge variant="primary">,</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.copilot_desc_num") }}
                </div>
            </div>
        </div>

        <div class="shortcuts-section">
            <div class="section-header">
                <div class="os-header">
                    <i class="fa-brands fa-apple"></i>
                    <h3>{{ $t("message.macOS") }}</h3>
                </div>
                <div class="divider"></div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Command</b-badge>
                    +
                    <b-badge variant="primary">M</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.openPrivateChat") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">ESC</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.escKey") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Command</b-badge>
                    +
                    <b-badge variant="primary">K</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("search.searchAreaTitle") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">F1</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.focusInput") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">F4</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.previousOpenedChat") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">TAB</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.showSystemStatus") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Command</b-badge>
                    +
                    <b-badge variant="primary">,</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.copilot_desc_num") }}
                </div>
            </div>
        </div>

        <div class="shortcuts-section">
            <div class="section-header">
                <div class="os-header">
                    <i class="far fa-comment-dots"></i>
                    <h3>{{ $t("message.chatShortcuts") }}</h3>
                </div>
                <div class="divider"></div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge 
                        variant="success" 
                        v-tippy="{
                            content: $t('message.examplePm'),
                            placement: 'top',
                            theme: 'light-border'
                        }"
                    >pm:</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.pmDescription") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge 
                        variant="success"
                        v-tippy="{
                            content: $t('message.exampleName'),
                            placement: 'top',
                            theme: 'light-border'
                        }"
                    >@name</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t('message.nameDescription') }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge 
                        variant="success"
                        v-tippy="{
                            content: $t('message.exampleEmail'),
                            placement: 'top',
                            theme: 'light-border'
                        }"
                    >@email</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t('message.descriptionEmail') }}
                </div>
            </div>
        </div>

        <div class="shortcuts-section">
            <div class="section-header">
                <div class="os-header">
                    <i class="far fa-window-maximize"></i>
                    <h3>{{ $t("message.chatWindow") }}</h3>
                </div>
                <div class="divider"></div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Ctrl</b-badge>
                    +
                    <b-badge variant="primary">W</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.endConversation") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Ctrl</b-badge>
                    +
                    <b-badge variant="primary">F</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.redirectConversation") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Ctrl</b-badge>
                    +
                    <b-badge variant="primary">P</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.sendPrivateMessage") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Ctrl</b-badge>
                    +
                    <b-badge variant="primary">B</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.blockUser") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Ctrl</b-badge>
                    +
                    <b-badge variant="primary">T</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.createTask") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Ctrl</b-badge>
                    +
                    <b-badge variant="primary">O</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.showProfile") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">C</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.markAsAnswered") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Ctrl</b-badge>
                    +
                    <b-badge variant="primary">1</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.switchToChatLayout") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Ctrl</b-badge>
                    +
                    <b-badge variant="primary">2</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.switchToTableLayout") }}
                </div>
            </div>
            <div class="shortcut-item">
                <div class="shortcut-keys">
                    <b-badge variant="primary">Ctrl</b-badge>
                    +
                    <b-badge variant="primary">3</b-badge>
                </div>
                <div class="shortcut-description">
                    {{ $t("message.switchToKanbanLayout") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "KeyboardShortcuts",
};
</script>

<style scoped lang="scss">
.shortcuts-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
    padding: 1rem;
    max-width: 900px;
    margin: 0 auto;
}

.shortcuts-section {
    background: #ffffff;
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border: 1px solid #eaeaea;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .section-header {
        margin-bottom: 1rem;

        .os-header {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin-bottom: 0.5rem;

            i {
                font-size: 1.25rem;
                
                &.fa-windows {
                    color: #00a4ef;
                }
                
                &.fa-apple {
                    color: #666666;
                }
                
                &.fa-comment-dots {
                    color: #2ecc71;
                }
            }

            h3 {
                font-size: 1rem;
                font-weight: 600;
                color: #2c3e50;
                margin: 0;
            }
        }

        .divider {
            height: 2px;
            background: #eaeaea;
            border-radius: 2px;
        }
    }

    .shortcut-item {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 0.75rem;
        padding: 0.5rem 0;
        border-bottom: 1px solid #f5f5f5;
        font-size: 0.9rem;
        align-items: start;

        .shortcut-keys {
            display: flex;
            align-items: center;
            gap: 0.25rem;
            white-space: nowrap;
        }

        .shortcut-description {
            color: #4a5568;
            line-height: 1.4;
        }

        &:hover {
            cursor: pointer;
            background-color: #f8f9fa;
            padding: 0.5rem;
            margin: 0 -0.5rem;
            border-radius: 4px;
        }

        &:last-child {
            border-bottom: none;
        }
    }
}

::v-deep .badge {
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem;
    font-weight: 500;
    border-radius: 4px;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.02);
    }

    &.badge-primary {
        background: #0066ff;
    }

    &.badge-success {
        background: #2ecc71;
    }
}

@media (max-width: 768px) {
    .shortcuts-container {
        padding: 0.5rem;
        gap: 0.5rem;
    }

    .shortcuts-section {
        padding: 0.75rem;
    }
}
</style>
